// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3bEog","ranges":"BmiRanges_ranges__Cci_c"};